export default __webpack_public_path__ + "slices/main/assets/public/media/community-page-video.c05a9dfd91a984d570b3c318f3216ef4.mp4";